import { render, staticRenderFns } from "./EmailSetReminderModal.vue?vue&type=template&id=2edd3c28"
import script from "./EmailSetReminderModal.vue?vue&type=script&lang=js"
export * from "./EmailSetReminderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports